/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as sis from './SISApp'
import { componentApi, loadTranslations } from 'common'


export class K12GradReqOverviewDetailHeaderApi {
  async DeserializeData(gradReqResultHeaderDataJson : string) : Promise<sis.GradReqResultDetailHeaderData> {
    return await componentApi.call('sis', 'sis-k12-grad-req-overview-detail-header', 'K12GradReqOverviewDetailHeaderApi', 'DeserializeData', {
      gradReqResultHeaderDataJson,
    });
  }
}
export default new K12GradReqOverviewDetailHeaderApi()
